import {
  Box,
  ButtonLink,
  Heading,
  IconShare,
  Inline,
  List,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import { shareInsightsReportEmailHref } from '../resources/shareInsightsReportEmailLink';

export const Success = () => (
  <Box paddingY="large">
    <Stack space="gutter">
      <Heading level="3" weight="weak">
        Thanks for signing up!
      </Heading>
      <Text tone="secondary">
        Keep an eye on your inbox for all the latest insights and updates from
        SEEK Business including:
      </Text>
      <List>
        <Text tone="secondary">
          Trend Tracking: Access past and emerging industry trends,
          state-by-state insights, and price trends.
        </Text>
        <Text tone="secondary">
          Expert Analysis: Understand how trends impact the economy and
          Australian SMEs.
        </Text>
        <Text tone="secondary">
          Actionable insights: Understand the implications of trends on your
          business and make informed decisions.
        </Text>
      </List>

      <Box display="flex" justifyContent="center">
        <Inline space="small">
          <ButtonLink
            data={{ 'data-attribute': 'share-marketplace-insights-report' }}
            variant="solid"
            href={shareInsightsReportEmailHref}
          >
            Share <IconShare />
          </ButtonLink>
        </Inline>
      </Box>
    </Stack>
  </Box>
);
